import helper from '../../helper';

export default {
	state: {
		partChargeList: {
			loading: false,
			data: [],
		},
	},
	mutations: {
		requestList(state) {
			state.partChargeList.loading = true;
		},
		successList(state, data) {
			state.partChargeList = { loading: false, data };
		},
	},
	actions: {
		async getPartCharge({ commit }, params) {
			return helper(this, async () => {
				commit('requestList');
				const res = await a.api('findSfkmBfjfByXmid', params);
				if (res.result.length > 0) {
					for (let i = 0; i < res.result.length; i++) {
						res.result[i].is_bfjf = res.result[i].is_bfjf === 'YES';
					}
				}
				commit('successList', res.result);
			});
		},
	},
};
